import { Text } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';

interface OperationTypeProps {
  title: string;
}
export const OperationType = ({ title }: OperationTypeProps) => {
  return (
    <Box
      bg={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 0.45)}
      px={Spacing['inset.nano']}
      py={Spacing['inline.quarck']}
      borderRadius={BoxRadius.sm}>
      <Text color="brand.tertiary.dark" variant="semibold">
        {title}
      </Text>
    </Box>
  );
};
